


































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Optgroup, Option } from '@/entities/form'

@Component<BaseSelectInput>({
    model: {
        prop: 'value',
        event: 'change'
    }
})
export default class BaseSelectInput extends Vue {
    @Prop(String) public id!: string
    @Prop(String) public label?: string
    @Prop(String) public value!: string
    @Prop(Array) public options?: Array<Option<string>>
    @Prop({ type: Boolean, default: false }) public inline!: boolean
    @Prop(String) public placeholder?: string
    @Prop(Array) public optgroups?: Array<Optgroup<string>>
    @Prop({ type: Boolean, required: false, default: false })
    public readonly backgroundWhite!: boolean

    public get hasLabel() {
        return this.label !== undefined && this.label.length > 0
    }
}
